// removed by extract-text-webpack-plugin
module.exports = {"topLeft":"location__topLeft___3eRME pinTL","topRight":"location__topRight___2Rci- pinTR","bottomRight":"location__bottomRight___285xp pinBR","bottomLeft":"location__bottomLeft___1sR3O pinBL","all":"location__all___UuM_6 pinAll","center":"location__center___1LDaN pinCenter"};


//////////////////
// WEBPACK FOOTER
// ./packages/marvel-ui-position/Position/style/location.css
// module id = 38
// module chunks = 0 1 23